import { render } from "./ScrollButton.vue?vue&type=template&id=5917f550&scoped=true"
import script from "./ScrollButton.vue?vue&type=script&lang=js"
export * from "./ScrollButton.vue?vue&type=script&lang=js"

import "./ScrollButton.vue?vue&type=style&index=0&id=5917f550&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5917f550"]])

export default __exports__